import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Data`}</strong>{` returned by GraphQL comes back in the exact same shape that you asked for it, without having to travel across the network because it was already gathered at `}<a parentName="p" {...{
        "href": "/docs/glossary#build"
      }}>{`build time`}</a>{`.`}</p>
    <p>{`Since all data is combined in the data layer, it’s even possible to query multiple sources at the same time.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      